import gql from 'graphql-tag'

export const QueryFeedLastActivity = gql(`query feed_get_last_activity($auid: String!, $feed_id: ID!) {
    getFeedLastActivity(auid: $auid, feed_id: $feed_id)
  }`)



// WEBPACK FOOTER //
// ./src/graphql/QueryFeedLastActivity.js